import Image from "next/image";

export function LogoMark({
  className,
  invert,
}: {
  className?: string;
  invert?: boolean;
}) {
  return (
    <Image
      src="/logo.png"
      alt="PeakWave"
      width={200}
      height={200}
      sizes="(max-width: 768px) 36px, 44px"
      className={`w-auto h-9 md:h-11 ${invert ? "brightness-0 invert" : ""} ${className ?? ""}`}
    />
  );
}
